import React from 'react';

import { Box, Flex } from '@rover/kibble/core';

import SkillTag from './SkillTag';

const MAX_TAGS = 3;

export type SkillTagItem = { id: string; label: string };

export type Props = { tags?: SkillTagItem[] | null };

const SkillTagRow = ({ tags }: Props): React.ReactElement | null => {
  if (!tags || tags.length === 0) return null;
  return (
    <Flex
      flexDirection="row"
      flexWrap="wrap"
      gap="2x"
      pt="4x"
      alignItems="flex-start"
      justifyContent="flex-start"
      data-testid="skill-tag-row"
      // A list keeps screen readers from merging the tags with the card text before them.
      webProps={{ role: 'list' }}
    >
      {tags.slice(0, MAX_TAGS).map((t) => (
        <Box key={t.id} webProps={{ role: 'listitem' }}>
          <SkillTag label={t.label} />
        </Box>
      ))}
    </Flex>
  );
};

export default SkillTagRow;
